export const setFilterListMap = (response) => {
    return function (dispatch) {
        dispatch({
            type: "FILTER_LIST",
            payload: response,
        });
    };
};
